import cx from 'classnames';
import React from 'react';

import * as styles from './Section.module.css';

const Section = ({
	children,
	pull,
	bleed,
	gap = 'lg',
	padding = 'xl',
	spacebelow,
	background,
	id,
	breakoutImage,
	clamp,
	...rest
}: {
	children: React.ReactNode;
	pull?: boolean;
	bleed?: boolean;
	gap?: 'no' | 'md' | 'lg' | 'xl';
	padding?: 'no' | 'md' | 'lg' | 'xl';
	spacebelow?: 'md' | 'lg' | 'xl';
	background?:
	| 'white'
	| 'blue'
	| 'lightBlue'
	| 'grey'
	| 'darkGrey'
	| 'darkerGrey'
	| 'lightGrey';
	id?: string;
	breakoutImage?: boolean;
	clamp?: boolean;
}) => {
	return (
		<section
			className={cx(
				styles.section,
				styles[`${gap}Gap`],
				styles[`${background}Background`],
				styles[`${spacebelow}Spacebelow`],
				{
					[styles.breakoutImage]: breakoutImage,
					[styles.pull]: pull,
					[styles.bleed]: bleed,
					[styles.clamp]: clamp,
				}
			)}
			id={id}
		>
			<div
				className={cx(
					styles.layout,
					styles[`${gap}Gap`],
					styles[`${padding}Padding`]
				)}
			>
				{children}
			</div>
		</section>
	);
};

export default Section;
